/** Bounds waiting without disguising a failed operation as a successful one.
 * Does not cancel the underlying native operation; never retry a payment with it.
 */
export function withTimeout<T>(operation: Promise<T>, milliseconds: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`${label}: tempo de espera excedido`)), milliseconds);
    operation.then(
      value => { clearTimeout(timer); resolve(value); },
      error => { clearTimeout(timer); reject(error); },
    );
  });
}
